const translations = {
    normal: "Normal",
    fighting: "Peleador",
    flying: "Volador",
    poison: "Venenoso",
    ground: "Terrestre",
    rock: "Roca",
    bug: "Insecto",
    ghost: "Fantasma",
    steel: "Acero",
    fire: "Fuego",
    water: "Acuático",
    grass: "Hierba",
    electric: "Eléctrico",
    ice: "Hielo",
    psychic: "Psíquico",
    dark: "Tenebroso",
    dragon: "Dragón",
    fairy: "Mágico",
    unknown: "Desconocido",
    shadow: "Sombra",
};

export default translations;
